import React from 'react';

const Assinaturas = () => {
  const assinaturas = [
    { nome: 'João Silva', email: 'joao@teste.com', status: 'Ativa' },
    { nome: 'Maria Souza', email: 'maria@teste.com', status: 'Pendente' },
    { nome: 'Pedro Lima', email: 'pedro@teste.com', status: 'Suspensa' },
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Assinaturas</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded shadow">
          <thead>
            <tr>
              <th className="text-left p-2">Nome</th>
              <th className="text-left p-2">E-mail</th>
              <th className="text-left p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {assinaturas.map((a, idx) => (
              <tr key={idx} className="border-t">
                <td className="p-2">{a.nome}</td>
                <td className="p-2">{a.email}</td>
                <td className="p-2">
                  <span
                    className={`px-2 py-1 rounded text-xs ${
                      a.status === 'Ativa'
                        ? 'bg-green-100 text-green-800'
                        : a.status === 'Pendente'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {a.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Assinaturas;
